export default {
  setCompanyList(state, companyList) {
    state.companiesList = companyList
  },
  setCompany(state, company) {
    state.company = company
  },
  // Only the peppol_* fields: the rest of the company may hold unsaved
  // edits of the main form.
  setCompanyPeppol(state, company) {
    for (const [key, value] of Object.entries(company)) {
      if (key.startsWith('peppol_')) state.company[key] = value
    }
  },
  setMetadata(state, metadata) {
    state.metadata = metadata
  },
  setCompanyActivity(state, activity) {
    state.companyActivity = activity
  }
}
